<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-bezahlen"></div>
    </div>
    <h2>{{evaluateLanguageString(modalData.title)}}</h2>
    <div>
      <p class="content-text">{{evaluateLanguageString(modalData.description)}}</p>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <div class="ya-button-container">
            <button mat-flat-button (click)="confirm()">
              <span>{{evaluateLanguageString(modalData.buttonText)}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>